'user strict'
/**
 * 公共函数封装
 * author:qinyifang@XGD.com
 */
import { getCent2Yuan, dayjs } from '@jlpay/utils'
export {
  setSession, // 存储sessionstarage
  getSession, // 获取sessionstarage
  removeSession, // 删除sessionstarage
  removeAllSession, // 删除 all sessionstarage
  setLocal, // 存储localstarage
  getLocal, // 获取localstarage
  removeLocal, // 移除localstarage
  removeAllLocal, // 移除所有localstarage
  resetKeyboard // 键盘兼容性函数
} from '@jlpay/utils'

export {
  getFormatDate, // 格式化日期
  getFormatYuanAmt, // 以分为单位的金额转换为以元为单位(整数部分加千分号)
  showLoading, // 设置loading
  getPayEnv, // 获取支付环境
  getProjectType, // 获取项目类型
  getDeviceType // 判断当前浏览器是pc端还是移动端
}
/**
 * date 为long类型
 * format 为格式化参数
 */
function getFormatDate(date, format) {
  if (date === undefined) {
    return ''
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  if (format === undefined) {
    format = 'YYYY-MM-DD HH:mm:ss'
  } else {
    const replacements = {
      y: 'Y',
      d: 'D',
      h: 'H'
    }
    format = format.replace(/[ydh]/g, (match) => replacements[match])
  }
  return dayjs(date).format(format)
}
// 以分为单位的金额转换为以元为单位(整数部分加千分号)
function getFormatYuanAmt(money) {
  return getCent2Yuan(money, true)
}

// 设置loading
function showLoading(flag) {
  const elem = document.querySelector('#jl-loading')
  elem & (elem.style.display = flag ? 'flex' : 'none')
}

const user_agent = window.navigator.userAgent.toLowerCase() || ''
const isWx = user_agent.indexOf('micromessenger') > -1
const isAli = user_agent.indexOf('aliapp') > -1
const isUnion = user_agent.indexOf('unionpay') > -1
// 获取环境
function getPayEnv() {
  let source = 'browser'
  if (isWx) {
    source = 'wxpay'
  }
  if (isAli) {
    source = 'alipay'
  }
  if (isUnion) {
    source = 'unionpay'
  }
  return source
}

// 获取项目类型
function getProjectType() {
  const pathname = window.location.pathname
  if (pathname.startsWith('/risk/')) {
    return 'risk'
  } else if (pathname.startsWith('/support/')) {
    return 'support'
  } else {
    return ''
  }
}

// 判断当前浏览器是pc端还是移动端
function getDeviceType() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return 'mobile'
  } else {
    return 'pc'
  }
}
